const ordinalWords = [
  "first",
  "second",
  "third",
  "fourth",
  "fifth",
  "sixth",
  "seventh",
  "eighth",
  "ninth",
  "tenth",
];

const getOrdinalLabel = (index: number) => {
  const value = index + 1;
  const mod100 = value % 100;
  if (mod100 >= 11 && mod100 <= 13) {
    return `${value}th`;
  }
  const mod10 = value % 10;
  if (mod10 === 1) return `${value}st`;
  if (mod10 === 2) return `${value}nd`;
  if (mod10 === 3) return `${value}rd`;
  return `${value}th`;
};

export const getOrdinalWord = (index: number) => ordinalWords[index] ?? getOrdinalLabel(index);

export const getSingularLabel = (label?: string) => {
  if (!label) return "item";
  const trimmed = label.trim();
  if (trimmed.toLowerCase().endsWith("ies")) {
    return `${trimmed.slice(0, -3)}y`;
  }
  if (trimmed.toLowerCase().endsWith("ses")) {
    return trimmed.slice(0, -2);
  }
  if (trimmed.toLowerCase().endsWith("s")) {
    return trimmed.slice(0, -1);
  }
  return trimmed;
};
